<template lang="pug">
div.preview-element.poster-background(:style="wrapStyle")
	slot
</template>

<script>
import {computed} from "vue";

export default {
	name: "PosterBackground",
	props: {
		selectedItems: {
			type: Object,
			default() {
				return {}
			}
		},

		spec: {
			type: Object,
			default() {
				return {}
			}
		},

		dimensions: {
			type: Object,
			default() {
				return {}
			}
		},

		borderColor: {
			type: String,
			default: ""
		},

		fixBackgroundColor: {
			type: String,
			default: ''
		}
	},

	setup(props) {

		const wrapStyle = computed(() => {
			var output =  '';

			var w = props.spec.background ? props.spec.background.width : 100;
			var h = props.spec.background ? props.spec.background.height : 100;
			var top = props.spec.background ? props.spec.background.top : 0;
			var left = props.spec.background ? props.spec.background.left : 0;
			var bg = props.selectedItems.background_color ? props.selectedItems.background_color.value : '';

			if((!!props.fixBackgroundColor) )
				bg = props.fixBackgroundColor;

			output = `
			width: ${w}%;
			height: ${h}%;
			background-color: ${bg};
			top: ${top}%;
			left: ${left}%;
			`;
			return output;
		})

		return {
			wrapStyle
		}
	}
}
</script>

<style lang="scss">
	.preview-element {
		&.poster-border {
			position: absolute;
			border: 1px solid transparent;
			width: 100%;
			height: 100%;
			margin: auto;
			left: 0;
			right: 0;
			top: 0;
			bottom: 0;
		}
	}
</style>
